import { SxProps, Theme } from '@mui/material';

export const stylesCookiesListPaper: SxProps<Theme> = { p: 2 };
